export function addSpace (price) {
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(price)
}


// WEBPACK FOOTER //
// ./src/utils/priceFormat.js